document.documentElement.classList.add('srl-js');
const srlHeader = document.querySelector('.shopify-section-header-sticky');
if (srlHeader) {
  const updateHeader = () => srlHeader.classList.toggle('srl-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

document.querySelectorAll('[data-srl-device-scroll]').forEach((button) => {
  button.addEventListener('click', () => {
    const section = button.closest('.srl-priority-products');
    const track = section?.querySelector('.srl-priority-grid');
    const card = track?.querySelector('.srl-priority-card');
    if (!track || !card) return;

    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const direction = button.dataset.srlDeviceScroll === 'previous' ? -1 : 1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });
});
